import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const addProductFunc = createAsyncThunk(
    "addProduct",
    async ({ data }, thunkAPI) => {
        try {
            const res = await api.post(`dashboard/products`, data);
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
        }
    }
)
const addProductSlicer = createSlice({
    name: "addProduct",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(addProductFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
        .addCase(addProductFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";
            })
        .addCase(addProductFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
});
export default addProductSlicer.reducer;